<template>
  <div style="display: flex; gap: 10px" :data-testid="getTestId(`fix-delete-btn-container-${item.id}`)">
    <v-btn
      small
      outlined
      class="solvit-crud-outline-btn solvit-crud-outline-btn--primary"
      :title="$t('common.edit')"
      :data-testid="getTestId(`edit-button-${item.id}`)"
      @click="editItem(item)"
    >
    <v-icon left>
        mdi-pencil
      </v-icon> {{ $t('common.edit') }}
    </v-btn>
    <v-btn
      small
      outlined
      class="solvit-crud-outline-btn solvit-crud-outline-btn--danger mr-2"
      :title="$t('common.delete')"
      :data-testid="getTestId(`delete-button-${item.id}`)"
      @click="deleteItem(item)"
    >
      <v-icon left>
        mdi-delete
      </v-icon> {{ $t('common.delete') }}
    </v-btn>
  </div>
</template>
<script>
import { getTestId } from '@/utils/testUtils';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  emits: ['editItem', 'deleteItem'],
  methods: {
    editItem(item) {
      this.$emit('editItem', item);
    },
    deleteItem(item) {
      this.$emit('deleteItem', item);
    },
    getTestId(testId) {
      return getTestId(testId);
    }
  }
};
</script>
